import axios, { AxiosResponse } from 'axios';
import { put, takeLatest, select , all, takeEvery} from 'redux-saga/effects';
import actions from '@state/actions';
import selectors from '@state/selectors';
import { serverError } from '@state/auth/actions';
import host from '@utils/host';
import * as actionsTypes from './constants';
import * as actionsInterfaces from './types';
import { UserManager } from 'oidc-client';

function* fetchParsedTrees(action: actionsInterfaces.IFetchParsedTreesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}parsedTrees`    
    if(action.query)callUrl=`${host}parsedTrees${action.query}`

    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.parsedTrees.setParsedTrees(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* getParsedTree(action: actionsInterfaces.IFetchParsedTreeAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}parsedTrees`    
    if(action.query)callUrl=`${host}parsedTrees${action.query}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.parsedTrees.setParsedTree(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* addParsedTree(action: actionsInterfaces.IPostParsedTreeAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}parsedTrees`, action.parsedTree,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.parsedTrees.addSuccessParsedTree({status: response.status, id: action.parsedTree.id}));
      if (action.callback) { action.callback(response.data[0]); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      yield put(actions.parsedTrees.addSuccessParsedTree({status: response.status, id: action.parsedTree.id}));
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchSearchParsedTree(action: actionsInterfaces.IFetchParsedTreesAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}parsedTrees`    
    if(action.query)callUrl=`${host}parsedTrees${action.query}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.parsedTrees.setSearchParsedTree(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* fetchCounterParsedTree(action: actionsInterfaces.IFetchCounterAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}parsedTreescount`    
    if(action.filter)callUrl=`${host}parsedTreescount${action.filter}`
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.parsedTrees.setCounterParsedTree(response.data[0]));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateParsedTree(action: actionsInterfaces.IUpdateParsedTreeAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.put(`${host}parsedTrees/${action.parsedTree.id}`,action.parsedTree,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateParsedTreeElements(action: actionsInterfaces.IUpdateParsedTreeElementsAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}update-parsedtree-elements?saveVersion=${action.saveVersion}`,action.updateElementsInfo,{headers: {Authorization: token}})
    yield put(actions.parsedTrees.setUpdateParsedTreeElements(response.status));
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateArtboardPreview(action: actionsInterfaces.IUpdateArtboardPreviewAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let response: AxiosResponse<any>;
    if (!action.inmediate) {
      response = yield axios.post(`${host}UpdatePreview?id=${action.id}&name=${action.name}`,action.data,{headers: {Authorization: token}})
    }
    else {
      response = yield axios.post(`${host}UpdatePreviewInmediate?id=${action.id}&name=${action.name}`,action.data,{headers: {Authorization: token}})
    }
    //yield put(actions.parsedTrees.setUpdateParsedTreeElements(response.status));
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* exportArtboardMedia(action: actionsInterfaces.IExportArtboardMediaAction) {
  let token: string;
  try {

    let data = {"access_token":action.access_token, "data":action.data};
    token = yield select(selectors.auth.getAuthToken);
    let response: AxiosResponse<any>;
    if (action.overwrite)
      response = yield axios.put(`${host}external/${action.dealerId}/assets/${action.collection}/_overwrite/${action.prefix}`,data,{headers: {Authorization: token}})
    else
      response = yield axios.put(`${host}external/${action.dealerId}/assets/${action.collection}/${action.prefix}`,data,{headers: {Authorization: token}})
   //yield put(actions.parsedTrees.setUpdateParsedTreeElements(response.status));
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}


function* updateParsedTreeField(action: actionsInterfaces.IUpdateParsedTreeFieldAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}update-parsedtree-field`,action.updateFieldInfo,{headers: {Authorization: token}})
    yield put(actions.parsedTrees.setUpdateParsedTreeField(response.status));
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateParsedTreeFieldTags(action: actionsInterfaces.IUpdateParsedTreeFieldTagsAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}parsedTreeFieldTags`,action.updateFieldTagsInfo,{headers: {Authorization: token}})
    yield put(actions.parsedTrees.setUpdateParsedTreeFieldTags({status: response.status, snackBar: action.updateFieldTagsInfo.snackBar}));
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateParsedTreeFieldsTags(action: actionsInterfaces.IUpdateParsedTreeFieldsTagsAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}parsedTreeFieldsTags`,action.updateFieldsTagsInfo,{headers: {Authorization: token}})
    yield put(actions.parsedTrees.setUpdateParsedTreeFieldsTags(response.status));
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* updateParsedTreeTemplateFields(action: actionsInterfaces.IUpdateParsedTreeTemplateFieldsAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    const response: AxiosResponse<any> = yield axios.post(`${host}parsedTreeTemplateFields`,action.updateTemplateFieldsInfo,{headers: {Authorization: token}})
    yield put(actions.parsedTrees.setUpdateParsedTreeTemplateFields(response.status));
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}


function* fetchParsedTreeChanges(action: actionsInterfaces.IFetchParsedTreeChangesAction) {
  let token: string;  
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}parsedTreeChanges/${action.id}?version=${action.version}&start=${action.start}&pagelength=${action.length}`        
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.parsedTrees.setParsedTreeChanges(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* getParsedTreeChange(action: actionsInterfaces.IGetParsedTreeChangeAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}parsedTreeChange/${action.id}`          
    const response: AxiosResponse<any> = yield axios.get(callUrl,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      yield put(actions.parsedTrees.setParsedTreeChanges(response.data));
      if (action.callback) { action.callback(response.data); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

function* restoreParsedTreeChange(action: actionsInterfaces.IRestoreParsedTreeChangeAction) {
  let token: string;
  try {
    token = yield select(selectors.auth.getAuthToken);
    let callUrl=`${host}parsedTreeChange/${action.id}/restore?parsedTree=${action.parsedTree}`        
    const response: AxiosResponse<any> = yield axios.post(callUrl,action.userData,{headers: {Authorization: token}})
    if (response.status >= 200 && response.status <= 300) {
      if (action.callback) { action.callback(response); }  
    } else if (response.status === 400 || response.status === 401 || response.status === 403) {
      const userManager: UserManager = yield select(selectors.auth.getAuthUserManager);
      if (userManager) yield userManager.signoutRedirect();
      yield put(actions.auth.setAuth(undefined, undefined, undefined));
      if (action.callback) { action.callback(undefined, response); }  
    } else {
      yield put(serverError(response.data));
      if (action.callback) { action.callback(undefined, response); }  
    }  
  } catch (e) {
    yield put(serverError(e));
    if (action.callback) { action.callback(undefined, e); }    
  }
}

export default function* budgetSagas() {
  yield all([
    takeLatest(actionsTypes.FETCH_PARSEDTREES, fetchParsedTrees),
    takeLatest(actionsTypes.GET_PARSEDTREE_INFO, getParsedTree),
    takeEvery(actionsTypes.ADD_PARSEDTREE, addParsedTree),
    takeLatest(actionsTypes.FETCH_SEARCH_PARSEDTREE, fetchSearchParsedTree),
    takeLatest(actionsTypes.FETCH_COUNTER_PARSEDTREE, fetchCounterParsedTree),
    takeLatest(actionsTypes.UPDATE_PARSEDTREE, updateParsedTree),
    takeLatest(actionsTypes.UPDATE_PARSEDTREE_FIELD, updateParsedTreeField),
    takeLatest(actionsTypes.UPDATE_PARSEDTREE_FIELDTAGS, updateParsedTreeFieldTags),
    takeLatest(actionsTypes.UPDATE_PARSEDTREE_FIELDSTAGS, updateParsedTreeFieldsTags),
    takeLatest(actionsTypes.UPDATE_PARSEDTREE_TEMPLATEFIELDS, updateParsedTreeTemplateFields),
    takeLatest(actionsTypes.UPDATE_PARSEDTREE_ELEMENTS, updateParsedTreeElements),
    takeLatest(actionsTypes.UPDATE_ARTBOARD_PREVIEW, updateArtboardPreview),
    takeLatest(actionsTypes.FETCH_PARSEDTREECHANGES, fetchParsedTreeChanges),
    takeLatest(actionsTypes.GET_PARSEDTREECHANGE, getParsedTreeChange),
    takeLatest(actionsTypes.RESTORE_PARSEDTREECHANGE, restoreParsedTreeChange),
    takeLatest(actionsTypes.EXPORT_ARTBOARD_MEDIA, exportArtboardMedia),
  ])
}

